import { toQueryString } from 'utils/url-utils';

export const getDefaultFilter = () => {
  const result = toQueryString({
    showZeroAmountRows: false,
  });
  return result;
};
